import { useEffect, useState } from "react";
import { Sun, Moon } from "lucide-react";

const dark = () => window.matchMedia?.("(prefers-color-scheme: dark)").matches ?? true;
const apply = (t) => document.documentElement.classList.toggle("light", t === "light");

// Day / Night switch: follows the phone until you pick one (saved on this device)
export function ThemeToggle() {
  const [theme, setTheme] = useState(() => localStorage.getItem("lvrc-theme") || (dark() ? "dark" : "light"));
  useEffect(() => { apply(theme); }, [theme]);
  useEffect(() => {
    const mq = window.matchMedia?.("(prefers-color-scheme: dark)");
    const h = () => { if (!localStorage.getItem("lvrc-theme")) setTheme(mq.matches ? "dark" : "light"); };
    mq?.addEventListener?.("change", h);
    return () => mq?.removeEventListener?.("change", h);
  }, []);
  const flip = () => { const t = theme === "light" ? "dark" : "light"; localStorage.setItem("lvrc-theme", t); setTheme(t); };
  return (
    <button onClick={flip} data-testid="theme-toggle" title={theme === "light" ? "Switch to Night" : "Switch to Day"}
      className="p-2 rounded-md text-slate-400 hover:text-slate-100 hover:bg-[#1A2235] flex items-center gap-1.5 text-xs">
      {theme === "light" ? <Moon size={16} /> : <Sun size={16} />}<span className="hidden sm:inline">{theme === "light" ? "Night" : "Day"}</span>
    </button>
  );
}
